//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import * as instagramScheduleActions from '@instagram-account/redux/schedule/instagramScheduleSlice';
import {
  ICrossPostRecords,
  IInstagramScheduleModalState,
} from '@instagram-account/redux/schedule/modals/instagramScheduleModalModel';
import { SliceNames } from '@redux/SliceNames';
import { createThunk } from '@redux/createThunk';
import { WeekDayValue } from '@utils/moment';

const initialState: IInstagramScheduleModalState = {
  crossPostAttemptResultsModal: {
    crossPostRecords: undefined,
    isCrossPostAttemptResultsModalOpen: false,
  },
  isPostDeletedModalOpen: false,
  isSettingsModalOpen: false,
  startOfWeekDay: 0,
};

const { actions, reducer } = createSlice({
  name: SliceNames.InstagramAccountScheduleModals,
  initialState,
  reducers: {
    openCrossPostAttemptResultsModal(
      state,
      action: PayloadAction<ICrossPostRecords>,
    ) {
      state.crossPostAttemptResultsModal = {
        crossPostRecords: action.payload,
        isCrossPostAttemptResultsModalOpen: true,
      };
    },
    closeCrossPostAttemptResultsModal(state) {
      state.crossPostAttemptResultsModal = {
        crossPostRecords: undefined,
        isCrossPostAttemptResultsModalOpen: false,
      };
    },
    openPostDeletedModal(state) {
      state.isPostDeletedModalOpen = true;
    },
    closePostDeletedModal(state) {
      state.isPostDeletedModalOpen = false;
    },
    openSettingsModal(state) {
      state.isSettingsModalOpen = true;
    },
    closeSettingsModal(state) {
      state.isSettingsModalOpen = false;
    },
    setStartOfWeekDay(state, action: PayloadAction<WeekDayValue>) {
      state.startOfWeekDay = action.payload;
    },
  },
});

export const {
  openCrossPostAttemptResultsModal,
  closeCrossPostAttemptResultsModal,
  openPostDeletedModal,
  closePostDeletedModal,
  closeSettingsModal,
  setStartOfWeekDay,
} = actions;

export const openSettingsModal = createThunk(() => (dispatch, getState) => {
  const currentSetting = getState().instagram.schedule.startOfWeekDay;
  dispatch(actions.setStartOfWeekDay(currentSetting));
  dispatch(actions.openSettingsModal());
});

export const saveCalendarSettings = createThunk(
  () => async (dispatch, getState) => {
    const scheduleCalendarStartOfWeek =
      getState().instagram.schedule.modals.startOfWeekDay;
    await dispatch(
      instagramScheduleActions.setInteractiveCalendarSettings({
        scheduleCalendarStartOfWeek,
      }),
    );

    /**
     * Navigate the calendar to today to approximate a calendar
     * refresh with the new startOfWeekDat taken into account.
     */
    void dispatch(instagramScheduleActions.navigateCalendarToToday());
  },
);

export default reducer;
